export type RevenueIntelligenceChatAvailabilityState =
  | "offline"
  | "simplified"
  | "support";

type RequestError = Error & {
  code?: unknown;
  status?: unknown;
};

const SUPPORT_ERROR_CODES = new Set([
  "chat_capacity_unavailable",
  "chat_configuration_unavailable",
  "composer_unavailable",
  "planner_unavailable",
  "usage_tracking_unavailable",
]);

export function getRevenueIntelligenceChatAvailabilityState(
  error: unknown,
  online: boolean,
): RevenueIntelligenceChatAvailabilityState {
  if (!online) return "offline";
  if (!(error instanceof Error)) return "simplified";

  const typed = error as RequestError;
  const code = typeof typed.code === "string" ? typed.code : null;
  const status = typeof typed.status === "number" ? typed.status : null;

  if ((code && SUPPORT_ERROR_CODES.has(code)) || status === 503) {
    return "support";
  }
  return "simplified";
}

export function getRevenueIntelligenceChatAvailabilityMessage(
  state: RevenueIntelligenceChatAvailabilityState,
) {
  if (state === "offline") {
    return "You are offline. Reconnect to continue.";
  }
  if (state === "support") {
    return "Advanced analysis is temporarily unavailable. Answers may be simplified. If the problem continues, contact support@revelate.app.";
  }
  return "Advanced analysis is temporarily unavailable. Answers may be simplified.";
}
